
import React from 'react'
import { useClient } from 'jsonapi-react'
import AutoComplete from 'app/theme/forms/AutoComplete'

export default function CuisineAutocomplete(props) {
  const client = useClient()
  const { filter, place, baseUrl, ...rest } = props

  const maxMiles = 10

  const areaFilter = {}
  if ((place.type === 'city' && place.major) || !place.location) {
    areaFilter.city_id = place.id
  } else {
    areaFilter.service_area = {
      contains: JSON.stringify({ ...place.location, radius: maxMiles })
    }
  }

  return (
    <AutoComplete
      {...rest}
      label="Search All Cuisine Options"
      placeholder=""
      labelClassNames="text-base text-black font-bold mt-2"
      inputClassNames="text-sm border border-gray"
      resultsClassNames="relative grid grid-cols-2 gap-4 shadow-none border-none"
      resultClassNames="text-sm text-black font-light"
      getResults={term => {
        if (term.length < 1) {
          return null
        }
        return client.fetch(['tags', {
          filter: {
            search: term,
            primary: false,
            ...areaFilter,
            ...filter,
          },
          fields: {
            tags: ['name', 'slug']
          },
          extra_fields: {
            tags: ['total_caterers']
          },
          page: {
            size: 10,
          }
        }]).then(res => {
          return res.data
        })
      }}
      getLabel={tag => (
        `${tag.name}`
      )}
      onChange={(result) => {
        if(result?.slug) {
          window.location.href = `${baseUrl}/${result.slug}/`
        }
      }}
    />
  )
}